<template>
  <dn-chk-btn
    :class="classes"
    v-model="checked"
    :disabled="isDisabled"
  ><slot /></dn-chk-btn>
</template>



<script>
export default {
  props: {
    value: Boolean,
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    linkset: {
      type: String,
      default: null,
    },
  },



  computed: {
    classes() {
      return {
        'dn-ls-chk-btn': true,
      }
    },
    linkIsDisabled() { return !!this.linkset && this.$store.getters['links/disabled'](this.linkset) },
    isDisabled() { return this.disabled || this.linkIsDisabled },

    checked: {
      get() { return this.$ls.get(this.name, false) },
      set(val) {
        this.$ls.set(this.name, val);
        this.$emit('input', val);
      },
    },
  },



  watch: {
    value(val) {
      this.checked = val;
    },
  },



  created() {
    if (this.value) {
      this.checked = true;
    }
  },
}
</script>


// WEBPACK FOOTER //
// LsChkBtn.vue?0944140b